module.exports = __webpack_public_path__ + "static/assets/986e5b6fe9bcb9aebac9ea198cc84616.svg";